import type { ChatMessage } from '../types/telegram';
import { InlineKeyboard } from './InlineKeyboard';

interface MessageProps {
  message: ChatMessage;
  onCallback: (data: string, message: ChatMessage) => void;
  disabled?: boolean;
}

export function Message({
  message,
  onCallback,
  disabled = false,
}: MessageProps): React.JSX.Element {
  const isOutgoing = message.direction === 'outgoing';

  return (
    <div className={`flex ${isOutgoing ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[80%] rounded-2xl px-3 py-2 ${
          isOutgoing
            ? 'rounded-br-sm bg-telegram-message-out dark:bg-telegram-message-out-dark'
            : 'rounded-bl-sm bg-telegram-message-in shadow-sm dark:bg-telegram-message-in-dark'
        }`}
      >
        {message.text !== undefined && message.text !== '' && (
          <p className="whitespace-pre-wrap break-words text-sm">{message.text}</p>
        )}

        {message.reply_markup && (
          <InlineKeyboard
            markup={message.reply_markup}
            message={message}
            onCallback={onCallback}
            disabled={disabled}
          />
        )}

        <div
          className={`mt-1 flex items-center gap-1 text-[10px] text-telegram-text-secondary dark:text-telegram-text-secondary-dark ${
            isOutgoing ? 'justify-end' : 'justify-start'
          }`}
        >
          <span>
            {new Date(message.date * 1000).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
          {message.edit_date !== undefined && <span>(edited)</span>}
        </div>
      </div>
    </div>
  );
}
